import { typographyVariants } from '@/components/primitives/Typography';
import { useThemedColors } from '@/hooks/useThemedColors';
import { cn } from '@/utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const linkVariants = cva(
  'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        'paragraph-link': cn(typographyVariants({ variant: 'paragraph-link' })),
        'body1-link': cn(typographyVariants({ variant: 'body1-link' })),
      },
    },
    defaultVariants: {
      variant: 'paragraph-link',
    },
  }
);

export interface LinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    VariantProps<typeof linkVariants> {
  asChild?: boolean;
  active?: boolean;
}

export const ExternalLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, variant = 'paragraph-link', children, ...props }, ref) => {
    const { getExternalLinkColors } = useThemedColors();

    return (
      <a
        ref={ref}
        className={cn(
          linkVariants({ variant }),
          getExternalLinkColors(),
          className
        )}
        {...props}
      >
        {children}
      </a>
    );
  }
);

ExternalLink.displayName = 'ExternalLink';
